/** Lights through Home Assistant — REST calls and shapes (server: src/routes/home.ts). */
import { request } from '../api.js';

export interface Light {
  id: string;
  name: string;
  on: boolean;
  /** 0–100, null when off or not dimmable. */
  brightness: number | null;
  dimmable: boolean;
  available: boolean;
}

export function listLights(): Promise<{ configured: boolean; lights: Light[] }> {
  return request('/home/lights');
}

export async function setLight(id: string, want: { on: boolean; brightness?: number }): Promise<Light> {
  return (await request<{ light: Light }>(`/home/lights/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(want) })).light;
}
